<template>
    <AuthenticatedShell full-bleed-brand>
        <div class="ea-config-layout">
            <div class="ea-config-scroll">
                <div class="wizard ea-config-wizard">
                    <section class="section command-list primary config-section">
                        <div class="config-panel">
                            <header class="config-header config-header--row">
                                <div class="config-header-text">
                                    <h2>Equipe e acessos</h2>
                                    <p class="config-lead">
                                        Convide pessoas por e-mail e veja quem tem acesso à conta.
                                    </p>
                                </div>
                                <button type="button" class="btn-add-user" @click="openAddUserModal">
                                    Adicionar usuário
                                </button>
                            </header>

                            <div class="config-body">
                                <div class="team-invite-row">
                                    <div class="form-group team-invite-input">
                                        <label class="config-label">Pesquisar ou convidar</label>
                                        <input
                                            v-model="emailUser"
                                            type="search"
                                            class="form-control config-input"
                                            placeholder="Pesquise ou adicione pessoas"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <button
                                        v-if="emailUser"
                                        type="button"
                                        class="btn-invite-icon"
                                        title="Enviar convite"
                                        @click="inviteUser"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" aria-hidden="true">
                                            <path
                                                fill="currentColor"
                                                d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                                            />
                                        </svg>
                                    </button>
                                </div>
                                <p
                                    v-if="emailUser && !loading && users.length > 0 && filteredUsers.length === 0"
                                    class="team-hint"
                                >
                                    Nenhum usuário encontrado com esse termo. Se o e-mail for válido, use o botão
                                    ao lado para enviar um convite.
                                </p>

                                <div v-if="loading" class="team-loading">
                                    <span>Carregando equipe…</span>
                                </div>
                                <p v-else-if="users.length === 0" class="team-hint">
                                    Nenhuma pessoa listada ainda. Use o campo acima para convidar por e-mail.
                                </p>
                                <template v-else>
                                    <h3 class="config-subtitle team-list-title">Pessoas com acesso</h3>
                                    <ul class="team-list">
                                        <li v-for="user in filteredUsers" :key="user.id" class="team-row">
                                            <div class="team-avatar" aria-hidden="true">
                                                {{ initialsFor(user) }}
                                            </div>
                                            <div class="team-meta">
                                                <span class="team-name">{{ user.name }}</span>
                                                <span class="team-email">{{ user.email }}</span>
                                            </div>
                                            <button
                                                type="button"
                                                class="btn-team-remove"
                                                title="Remover acesso (em breve)"
                                                disabled
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" aria-hidden="true">
                                                    <path
                                                        fill="currentColor"
                                                        d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                                                    />
                                                </svg>
                                            </button>
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </AuthenticatedShell>

    <Teleport to="body">
        <div
            v-if="showAddUserModal"
            class="team-modal-backdrop"
            role="presentation"
            @click.self="closeAddUserModal"
        >
            <div
                class="team-modal-dialog"
                role="dialog"
                aria-modal="true"
                aria-labelledby="team-add-user-title"
            >
                <div class="team-modal-head">
                    <h2 id="team-add-user-title" class="team-modal-title">Adicionar usuário</h2>
                    <button type="button" class="team-modal-close" aria-label="Fechar" @click="closeAddUserModal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.72 4.28a1 1 0 0 0-1.43 1.42L10.91 12l-6.6 6.3a1 1 0 0 0 1.38 1.38L12.35 13.37l6.43 6.13a1 1 0 0 0 1.43-1.42L13.8 12l6.4-6.09a1 1 0 1 0-1.43-1.42l-6.43 6.13-6.63-6.34Z"
                                fill="currentColor"
                            />
                        </svg>
                    </button>
                </div>
                <p class="team-modal-lead">
                    Preencha os dados para enviar um convite por e-mail. A API atual usa o e-mail; o nome segue no
                    pedido quando o backend suportar.
                </p>
                <div class="team-modal-body">
                    <div class="form-group">
                        <label class="config-label" for="team-add-name">Nome completo</label>
                        <input
                            id="team-add-name"
                            v-model.trim="addUserForm.name"
                            type="text"
                            class="form-control config-input"
                            placeholder="Ex.: Maria Silva"
                            autocomplete="name"
                        />
                    </div>
                    <div class="form-group">
                        <label class="config-label" for="team-add-email">E-mail</label>
                        <input
                            id="team-add-email"
                            v-model.trim="addUserForm.email"
                            type="email"
                            class="form-control config-input"
                            placeholder="nome@instituicao.edu.br"
                            autocomplete="email"
                            @keyup.enter="submitAddUserModal"
                        />
                    </div>
                </div>
                <div class="team-modal-footer">
                    <button type="button" class="btn-modal-secondary" @click="closeAddUserModal">Cancelar</button>
                    <button
                        type="button"
                        class="btn-modal-primary"
                        :disabled="addUserSubmitting"
                        @click="submitAddUserModal"
                    >
                        {{ addUserSubmitting ? 'Enviando…' : 'Enviar convite' }}
                    </button>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';
import AuthenticatedShell from '@/components/layout/AuthenticatedShell.vue';
import usersApi from '@/utils/users';
import { initialsFromFullName } from '@/utils/userDisplay';

export default {
    name: 'EscoConfiguracaoEquipe',
    components: { AuthenticatedShell },
    data() {
        return {
            users: [],
            emailUser: '',
            loading: false,
            showAddUserModal: false,
            addUserSubmitting: false,
            addUserForm: {
                name: '',
                email: ''
            }
        };
    },
    computed: {
        ...mapState(['token']),
        filteredUsers() {
            if (!this.emailUser) {
                return this.users;
            }
            return this.users.filter(user => {
                const email = user.email ? user.email.toLowerCase() : '';
                const name = user.name ? user.name.toLowerCase() : '';
                const search = this.emailUser.toLowerCase();
                return email.includes(search) || name.includes(search);
            });
        }
    },
    mounted() {
        this.fetchUsers();
    },
    watch: {
        showAddUserModal(open) {
            if (typeof document === 'undefined') return;
            document.body.style.overflow = open ? 'hidden' : '';
            if (open) {
                this._onEscAddUser = e => {
                    if (e.key === 'Escape') this.closeAddUserModal();
                };
                window.addEventListener('keydown', this._onEscAddUser);
            } else if (this._onEscAddUser) {
                window.removeEventListener('keydown', this._onEscAddUser);
                this._onEscAddUser = null;
            }
        }
    },
    beforeUnmount() {
        document.body.style.overflow = '';
        if (this._onEscAddUser) {
            window.removeEventListener('keydown', this._onEscAddUser);
        }
    },
    methods: {
        notify(msg, type = 'info') {
            toast(msg, { autoClose: 3000, type });
        },
        initialsFor(user) {
            return initialsFromFullName(user?.name);
        },
        async fetchUsers() {
            if (!this.token) return;
            try {
                this.loading = true;
                this.users = await usersApi.getUsers(this.token);
            } catch (e) {
                console.error(e);
                this.notify('Não foi possível carregar a equipe.', 'error');
            } finally {
                this.loading = false;
            }
        },
        async inviteUser() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.emailUser)) {
                this.notify('Informe um e-mail válido para convidar.', 'error');
                return;
            }
            const payload = { email: this.emailUser.trim() };
            try {
                await usersApi.inviteUser(this.token, payload);
                this.notify('Convite enviado com sucesso.', 'success');
            } catch (e) {
                console.error(e);
                this.notify('Erro ao enviar convite.', 'error');
            }
        },
        openAddUserModal() {
            this.addUserForm = { name: '', email: '' };
            this.showAddUserModal = true;
            this.$nextTick(() => {
                document.getElementById('team-add-name')?.focus?.();
            });
        },
        closeAddUserModal() {
            if (this.addUserSubmitting) return;
            this.showAddUserModal = false;
        },
        async submitAddUserModal() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const email = this.addUserForm.email.trim();
            if (!emailRegex.test(email)) {
                this.notify('Informe um e-mail válido.', 'error');
                return;
            }
            if (!this.token) return;
            const name = this.addUserForm.name.trim();
            const payload = { email };
            if (name) payload.name = name;
            this.addUserSubmitting = true;
            try {
                await usersApi.inviteUser(this.token, payload);
                this.notify('Convite enviado com sucesso.', 'success');
                this.showAddUserModal = false;
                this.addUserForm = { name: '', email: '' };
                await this.fetchUsers();
            } catch (e) {
                console.error(e);
                this.notify('Erro ao enviar convite.', 'error');
            } finally {
                this.addUserSubmitting = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$ea-accent: #8b9185;
$ea-accent-soft: rgba(139, 145, 133, 0.18);
$ea-card: #15161a;
$ea-elevated: #1c1d22;
$ea-muted: #8b9099;

.ea-config-layout {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.ea-config-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    padding: 0.5rem clamp(0.75rem, 2.5vw, 1.5rem) 1.25rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
}
.ea-config-scroll::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.ea-config-wizard {
    width: 100%;
    max-width: none;
}

.config-section {
    width: 100%;
    max-width: none;
    margin: 0;
    padding: 0;
}

.config-panel {
    background: $ea-card;
    border-radius: 12px;
    padding: clamp(1.25rem, 3vw, 2rem);
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: none;
}

.config-header h2 {
    margin: 0 0 0.35rem;
    font-size: clamp(1.25rem, 2.5vw, 1.6rem);
    color: #fff;
    font-weight: 700;
}

.config-header--row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1.25rem;
}

.config-header-text {
    flex: 1 1 220px;
    min-width: 0;
}

.config-header--row .config-lead {
    margin-bottom: 0;
}

.btn-add-user {
    flex-shrink: 0;
    padding: 0.55rem 1.15rem;
    border-radius: 10px;
    border: 1px solid rgba(139, 145, 133, 0.45);
    background: rgba(139, 145, 133, 0.22);
    color: #f2f3f5;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
}
.btn-add-user:hover {
    background: rgba(139, 145, 133, 0.35);
    border-color: rgba(139, 145, 133, 0.6);
}

.config-lead {
    margin: 0 0 1.25rem;
    color: $ea-muted;
    font-size: 14px;
    line-height: 1.55;
}

.config-header:not(.config-header--row) .config-lead {
    margin-bottom: 1.25rem;
}

.team-modal-backdrop {
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.25rem;
    background: rgba(8, 9, 12, 0.78);
    backdrop-filter: blur(6px);
}

.team-modal-dialog {
    width: 100%;
    max-width: 420px;
    max-height: min(90vh, 560px);
    overflow: auto;
    border-radius: 14px;
    background: $ea-card;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 24px 48px rgba(0, 0, 0, 0.45);
    outline: none;
}

.team-modal-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 1.1rem 1.15rem 0.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.team-modal-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 700;
    color: #fff;
    line-height: 1.3;
}

.team-modal-close {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #9aa3b2;
    cursor: pointer;
}
.team-modal-close:hover {
    background: rgba(255, 255, 255, 0.06);
    color: #e8eaef;
}

.team-modal-lead {
    margin: 0;
    padding: 0.75rem 1.15rem 0;
    font-size: 13px;
    line-height: 1.5;
    color: $ea-muted;
}

.team-modal-body {
    padding: 1rem 1.15rem 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.team-modal-body .form-group {
    margin: 0;
}

.team-modal-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.65rem;
    padding: 0.85rem 1.15rem 1.1rem;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.btn-modal-secondary {
    padding: 0.5rem 1rem;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: transparent;
    color: #c8cdd8;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}
.btn-modal-secondary:hover {
    background: rgba(255, 255, 255, 0.05);
}

.btn-modal-primary {
    padding: 0.5rem 1.15rem;
    border-radius: 10px;
    border: none;
    background: rgba(139, 145, 133, 0.85);
    color: #0f1012;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}
.btn-modal-primary:hover:not(:disabled) {
    background: rgba(160, 168, 155, 0.95);
}
.btn-modal-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.config-body {
    color: #fff;
}

.config-label {
    display: block;
    margin-bottom: 0.35rem;
    font-size: 13px;
    color: #c8cdd8;
}

.config-input {
    background: $ea-elevated !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    color: #fff !important;
    border-radius: 10px !important;
}
.config-input:focus {
    outline: none;
    border-color: rgba(139, 145, 133, 0.55) !important;
    box-shadow: 0 0 0 2px $ea-accent-soft;
}

.config-subtitle {
    margin: 1.25rem 0 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    color: #e8eaef;
}

.team-invite-row {
    display: flex;
    align-items: flex-end;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.team-invite-input {
    flex: 1 1 220px;
    margin: 0;
}

.btn-invite-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    background: rgba(139, 145, 133, 0.35);
    color: #f2f3f5;
    flex-shrink: 0;
    margin-bottom: 2px;
}
.btn-invite-icon:hover {
    background: rgba(139, 145, 133, 0.5);
}
.btn-invite-icon svg {
    width: 22px;
    height: 22px;
}

.team-hint {
    margin: 0.75rem 0 0;
    font-size: 13px;
    color: #9aa3b2;
}

.team-list-title {
    margin-top: 1.25rem;
}

.team-loading {
    padding: 1rem 0;
    color: $ea-muted;
    font-size: 14px;
}

.team-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.team-row {
    display: flex;
    align-items: center;
    gap: 0.85rem;
    padding: 0.65rem 0.75rem;
    border-radius: 10px;
    background: $ea-elevated;
    border: 1px solid rgba(255, 255, 255, 0.06);
}

.team-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #4a5a52;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.team-meta {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
}

.team-name {
    font-weight: 600;
    font-size: 14px;
    color: #f2f3f5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.team-email {
    font-size: 13px;
    color: $ea-muted;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.btn-team-remove {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    border: none;
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.35);
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.btn-team-remove svg {
    width: 18px;
    height: 18px;
}
</style>
